import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {_addNewKeyword} from "../../../../../services/apis/KeywordServices"

class CreateNewKeyword extends Component {
    state = {
        term: ''
    }

    _handleOnChangeTerm = e => {
        const {value} = e.target

        this.setState({
            term: value
        })
    }

    _handleSubmit = async e => {
        e.preventDefault()

        this._createNewKeyword()
    }

    _createNewKeyword = async () => {
        const {term} = this.state
        const {success, data} = await _addNewKeyword(term)

        if (success) {
            this.setState({
                term: ''
            })

            this.props.onCreate(data)
        }
    }

    render() {
        return (
            <div className="CreateNewKeyword col-md-3 col-12">
                <h4>Add new keyword</h4>
                <form onSubmit={this._handleSubmit}>
                    <div className="form-group">
                        <input
                            placeholder="Enter keyword"
                            value={this.state.term}
                            onChange={this._handleOnChangeTerm}
                            type="text"
                            className="form-control"/>
                    </div>

                    <div className="form-group">
                        <button type="submit" className="btn btn-primary">Add</button>
                    </div>
                </form>
            </div>
        )
    }
}

CreateNewKeyword.propTypes = {
    onCreate: PropTypes.func.isRequired,
}

export default CreateNewKeyword



// WEBPACK FOOTER //
// ./src/app/pages/dashboard/keywords/components/CreateNewKeyword.js